const Page404 = () => {
    return (
        'страница не найдена'
    );
};

export default Page404;